import React, { useState } from "react";
import { Drawer } from "antd";
import { Link, useLocation } from "react-router-dom";
import {
  HomeOutlined,
  FileTextOutlined,
  MailOutlined,
  UserOutlined,
  SettingOutlined,
  DownOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { Contact_url, About_url, HOME_URL } from "../../constants";

const ResponsiveDrawer = ({
  isOpen,
  onClose,
  logo,
  isDark = false,
  routes = [],
  activeItem,
  onItemClick,
  showAuth = false,
  onLogin,
  onSignup,
  userRole = "",
}) => {
  const location = useLocation();
  const isHomePage = location.pathname === HOME_URL;
  const textColor = isDark ? "text-white" : "text-dark";
  const drawerBg = isDark ? "#031B30" : "#ffffff";
  const [expandedItems, setExpandedItems] = useState({});

  const toggleExpand = (itemId) => {
    setExpandedItems(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  const homeMenus = [
    {
      id: 1,
      name: "Home",
      link: "/",
      icon: HomeOutlined,
    },
    {
      id: 2,
      name: "Find a Teacher",
      link: "/search?query=&gender=&modeOfTeaching=&cityId=&areaId=&course-level=&qualification-level=&education-board=",
      icon: UserOutlined,
    },
    {
      id: 3,
      name: "Blog",
      link: "/#BlogArticles",
      icon: FileTextOutlined,
    },
    {
      id: 12,
      name: "Contact Us",
      link: Contact_url,
      icon: MailOutlined,
    },
    {
      id: 13,
      name: "About Us",
      link: About_url,
      icon: SettingOutlined,
    },
  ];

  const menuItems = isHomePage ? homeMenus : routes;

  const renderMenuItem = (item, index, isChild = false) => {
    // Optional: Exclude Find a Teacher for non-home pages
    // if (userRole === "teacher" && item.name === "Find a Teacher") return null;

    const key = item.id || item.path || index;
    const hasChildren = item.children && item.children.length > 0;
    const isExpanded = expandedItems[key];

    return (
      <React.Fragment key={key}>
      <li
        className={`drawer-item d-flex align-items-center ${
          activeItem === key ? "active" : ""
        }`}
        onClick={() => {
          if (!hasChildren) {
            onItemClick(key);
            onClose();
          }
        }}
        style={{
          padding: "10px 14px",
          paddingLeft: isChild ? "28px" : "14px",
        }}
      >
        <span className="me-2">{item.icon && <item.icon size={22} />}</span>
        <Link
          to={hasChildren ? '#' : (item.link || item.path)}
          className={`text-decoration-none flex-grow-1 ${textColor}`}
          onClick={(e) => hasChildren ? e.preventDefault() : null}
        >
          {item.name}
        </Link>
        {hasChildren && (
          <span 
            onClick={(e) => {
              e.stopPropagation();
              toggleExpand(key);
            }}
            style={{ marginLeft: 'auto' }}
          >
            {isExpanded ? <DownOutlined /> : <RightOutlined />}
          </span>
        )}
      </li>
      
      {hasChildren && isExpanded && (
        <div style={{ marginLeft: isChild ? '28px' : '14px' }}>
          {item.children.map((child, i) =>
            renderMenuItem(child, `${key}-${i}`, true)
            )}
          </div>
        )}
      </React.Fragment>
    );
  };

  return (
    <Drawer
      placement="left"
      onClose={onClose}
      open={isOpen}
      closable={false}
      width={260}
      bodyStyle={{
        padding: "20px 16px",
        backgroundColor: drawerBg,
        display: "flex",
        flexDirection: "column",
        height: "100%",
        color: isDark ? "#ffffff" : "#000000",
      }}
    >
      {/* Top Section: Logo and Close */}
      <div className="d-flex justify-content-between align-items-center mb-4">
      <Link className="navbar-brand" to="/"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 44,
          padding: "0 16px",
        }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{ height: 30, cursor: "pointer",justifyContent: "center" }}
          />
        </Link>
        <span
          onClick={onClose}
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: isDark ? "#fff" : "#000",
          }}
        >
          ✕
        </span>
      </div>

      {/* Menu Items */}
      <ul className="d-flex flex-column gap-2 list-unstyled">
        {menuItems.map((item, index) => renderMenuItem(item, index))}
      </ul>

      {/* Auth Buttons */}
      {showAuth && (
        <div className="mt-4">
          <button
            onClick={() => {
              onClose();
              onLogin(true);
            }}
            className="btn btn-primary btn-sm w-100 mb-2 btn_contained_black"
          >
            Login
          </button>
          <button
            onClick={() => {
              onClose();
              onSignup(true);
            }}
            className="btn btn-primary btn-sm w-100 btn_contained_black"
          >
            Sign Up
          </button>
        </div>
      )}

      {/* Styles */}
      <style jsx>{`
        .drawer-item {
          border-radius: 8px;
          transition: background 0.2s;
          cursor: pointer;
        }

        .drawer-item:hover {
          background-color: ${isDark ? "#123456" : "#f5f5f5"};
        }

        .drawer-item.active {
          background-color: ${isDark ? "#0d3c68" : "#dbeafe"};
          font-weight: bold;
        }
      `}</style>
    </Drawer>
  );
};

export default ResponsiveDrawer;
